module.exports = __webpack_public_path__ + "img/0Q3B5795_Foamcore.5fdad995.jpg";